import { Box, Center, Heading, Show } from "@chakra-ui/react";
import React from "react";
import {
  MediumProjectCard,
  ProjectCards,
} from "../components/Projects/ProjectCards";

import myglow_one from "../images/myglow_one.png";
import myglow_two  from "../images/myglow_two.png";
import myglow_three  from "../images/myglow_three.png";
import myglow_four  from "../images/myglow_four.png";
// import myglow_five  from "../images/myglow_five.png";

import career_one from "../images/career-1.png";
import career_two  from "../images/career-2.png";
import career_three  from "../images/career-3.png";
import career_four  from "../images/career-4.png";
import career_five  from "../images/career-5.png";

import charityhero_one from "../images/charityhero_one.png";
import charityhero_two  from "../images/charityhero_two.png";
import charityhero_three  from "../images/charityhero_three.png";
import charityhero_four  from "../images/charityhero_four.png";
// import charityhero_five  from "../images/charityhero_five.png";

import medweb_one from "../images/medweb_one.png";
import medweb_two  from "../images/medweb_two.png";
import medweb_three  from "../images/medweb_three.png";



const Projects = () => {

  const myglow=[
    myglow_one ,
    myglow_two,
   myglow_three  ,
   myglow_four ,
  //  myglow_five

  ];
  const career = [
 career_one ,
 career_two,
 career_three  ,
 career_four ,
 career_five ,

  ];

  const charityhero=[
    charityhero_one ,
    charityhero_two,
    charityhero_three  ,
    charityhero_four ,
    // charityhero_five,
    ]

    const medweb=[
      medweb_one ,
      medweb_two,
      medweb_three  ,
    
      ]
  return (
    <Box
      pl={{
        base: "5",
        sm: "5",
        md: "5",
        lg: "10",
        xl: "10",
        "2xl": "10",
      }}
      pr={{
        base: "5",
        sm: "5",
        md: "5",
        lg: "10",
        xl: "10",
        "2xl": "10",
      }}
      id="projects"
    >
      <Center>
        <Heading mb={"40px"}>Projects</Heading>
      </Center>

      <ProjectCards
        direction={"row-reverse"}
        deployedLink={"https://careermantra.netlify.app/"}
        image={career}
        title={"Career-Mantra"}
        subTitle={"Education Platform"}
        GithubLink={"https://github.com/borsejugal23/next-ray-854"}
        features={[
          "Signup and login The platform provides a user-friendly signup",
          "Searching filtring Functionality Users can filter for specific Colleges/Universities",
          "User can get complete information of Colleges/Universities",
          "Admin has access to update and delete the database"
        ]}
        description={
          "Find World's Top Colleges/Universities suitable for you | Get Admission in Top Universities in Abroad | Get up to 100% Scholarship in Top Colleges/Universities."
        }
        techStack={["React.js", "Redux","Chakra UI", "JavaScript"]}
      />
      <Show breakpoint="(max-width: 993px)">
        <MediumProjectCard
          image={career}
          deployedLink={"https://effulgent-cucurucho-980cc9.netlify.app/"}
          GithubLink={"https://github.com/borsejugal23/next-ray-854"}
          title={"Career-Mantra"}
          subTitle={"Education Platform"}
          description={
            "Find World's Top Colleges/Universities suitable for you | Get Admission in Top Universities in Abroad | Get up to 100% Scholarship in Top Colleges/Universities."
          }
          techStack={["React.js", "Redux","Chakra UI", "JavaScript"]}
        />
      </Show>


      <ProjectCards
        direction={"row-reverse"}
        deployedLink={"https://my-glow-ankush3681.vercel.app/"}
        image={myglow}
        title={"MyGlow"}
        subTitle={"Cosmatics seller"}
        GithubLink={"https://github.com/ank501/My_Glow"}
        features={[
          "Signup and login The platform provides a user-friendly signup",
          "purchase wide range of cosmetics",
          "User explore various beauty products ",
          "Admin can add products and update"
        ]}
        description={
          "My Glow is e-commerce website for Cosmetics, which provides a wide range of beauty products for women "
        }
        techStack={["React.js", "Redux","Chakra UI","Javascript"]}
      />
      <Show breakpoint="(max-width: 993px)">
        <MediumProjectCard
         deployedLink={"https://my-glow-ankush3681.vercel.app/"}
         image={myglow}
         title={"MyGlow"}
         subTitle={"Cosmatics seller"}
         GithubLink={"https://github.com/ank501/My_Glow"}
         description={
           "My Glow is e-commerce website for Cosmetics, which provides a wide range of beauty products for women "
         }
         techStack={["React.js", "Redux","Chakra UI","Javascript"]}
        />
      </Show>












      <ProjectCards
        direction={"row-reverse"}
        deployedLink={"https://mellifluous-otter-953555.netlify.app/"}
        image={charityhero}
        title={"CharityHero"}
        subTitle={"Donation site"}
        GithubLink={"https://github.com/ank501/CharityHero-Donation-Managment-App"}
        features={[
          "Signup and login The platform provides a user-friendly signup ",
          "Searching filtring Functionality Users can search for specific Cause and donation ",
          "User can submit their case, admin need to check and approve it for listing",
          "Donor can donate using multiple payment method"
        ]}
        description={
           "The objective of the project is to create a platform that enables users to create posts and raise charity funds through them. The system consists of two main components: the admin side and the user side."
        }
        techStack={["HTML","CSS", "Javascript","React.js","MongoDB","Redux"]}
      />
      <Show breakpoint="(max-width: 993px)">
        <MediumProjectCard
           deployedLink={"https://mellifluous-otter-953555.netlify.app/"}
           image={charityhero}
           title={"CharityHero"}
           subTitle={"Donation site"}
           GithubLink={"https://github.com/ank501/CharityHero-Donation-Managment-App"}
           description={
              "The objective of the project is to create a platform that enables users to create posts and raise charity funds through them. The system consists of two main components: the admin side and the user side."
           }
           techStack={["HTML","CSS", "Javascript","React.js","MongoDB","Redux"]}
        />
      </Show>






      <ProjectCards
        direction={"row-reverse"}
        deployedLink={"https://subtle-basbousa-142520.netlify.app/"}
        image={medweb}
        title={"MedWeb"}
        subTitle={"Medicine"}
        GithubLink={"https://github.com/ank501/MedWeb"}
        features={[
          "Online Medicine provider",
          "User can select the medicine on the basis of brands ",
          "User can check complete details on medicine detail page."
         
        ]}
        description={
          "Our goal is to make medical provide very fast and give relief from long que waiting for medicine."
        }
        techStack={["HTML","CSS", "Javascript","React"]}
      />
      <Show breakpoint="(max-width: 993px)">
        <MediumProjectCard
          image={medweb}
          deployedLink={"https://quiet-cajeta-869443.netlify.app/"}
          GithubLink={"https://github.com/borsejugal23/Clothies"}
          title={"Medweb"}
          subTitle={"e-commerce"}
          description={
            "Our goal is to make medwebping for children's apparel and care items hassle-free and enjoyable, offering a wide selection of trendy clothes and practical products that cater to the unique needs of both parents and their precious children."
          }
          techStack={["HTML","CSS", "Javascript"]}
        />
      </Show>






      {/* <ProjectCards
        direction={"row-reverse"}
        deployedLink={"https://energized-baseball-7687.vercel.app/"}
        image={career}
        title={"Busy Kids"}
        subTitle={"virtual bank"}
        GithubLink={"https://github.com/RoshanAAS/energized-baseball-7687"}
        features={[
          "Signup and login The platform provides a user-friendly signup ",
          "Searching filtring Functionality Users can search for specific Teacher",
          "Real-time payment integration using Razer Pay.",
          "Firebase Authentication is utilized for user authentication and authorization",
        ]}
        description={
          "Busy Kids is a virtual bank for kids, where you can teach them about the value of money in a safe environment. Kids will learn how to budget, save up for goals and spend responsibly using our cool easy-to-use app and website, while teachers have control over the students accounts and activities."
        }
        techStack={["React.js","Chakra UI", "FireBase", "Redux"]}
      />
      <Show breakpoint="(max-width: 993px)">
        <MediumProjectCard
          image={career}
          deployedLink={"https://energized-baseball-7687.vercel.app/"}
          GithubLink={"https://github.com/RoshanAAS/energized-baseball-7687"}
          title={"Busy Kids"}
          subTitle={"virtual bank"}
          description={
            "Busy Kids is a virtual bank for kids, where you can teach them about the value of money in a safe environment. Kids will learn how to budget, save up for goals and spend responsibly using our cool easy-to-use app and website, while teachers have control over the students accounts and activities."
          }
          techStack={["React.js","Chakra UI", "FireBase", "Redux"]}
        />
      </Show> */}
    </Box>
  );
};

export default Projects;
